const en = {
  errorFetchingDetails: 'Error fetching template details: {{message}}',
  errorLoadingDetails: 'Error loading details: {{message}}',
  errorLoadingTemplate: 'Error loading template: {{message}}',
  pleaseAddPart: 'Please add at least one part',
  failedToCreate: 'Failed to create template: {{error}}',
  failedToUpdate: 'Failed to update template: {{error}}',
  failedToDelete: 'Failed to delete template: {{error}}',
  equipmentCreatedSuccess: 'Equipment created successfully!',
  componentStockAddedSuccess: 'Component stock updated successfully!',
  failedToCreateEquipment: 'Failed to create equipment: {{error}}',
  erpBookingFailed:
    'WARNING: The equipment was created, but booking it in the ERP FAILED: {{error}}{{doc}}\nPlease book this production in the ERP manually.',
  title: 'Equipment Templates',
  subtitle: 'Manage reusable equipment configurations',
  createTemplateButton: '+ Create Template',
  brand: 'Brand',
  articleId: 'Article ID',
  parts: 'Parts',
  partsCount: '{{count}} parts',
  use: 'Use',
  createTemplateModalTitle: 'Create Equipment Template',
  templateNameLabel: 'Template Name *',
  articleIdPlaceholder: 'e.g. ART-001',
  partsWithCount: 'Parts ({{count}})',
  createTemplateSubmit: 'Create Template',
  editTemplateModalTitle: 'Edit Template',
  duplicate: 'Duplicate',
  duplicateTemplateModalTitle: 'Duplicate Template',
  copySuffix: '(Copy)',
  saveChanges: 'Save Changes',
  templateDetailsModalTitle: 'Template Details',
  templateNameField: 'Template Name',
  partsConfiguration: 'Parts Configuration',
  deleteTemplateTitle: 'Delete Template',
  deleteTemplateMessage: 'Are you sure you want to delete "{{name}}"?',
  useTemplateModalTitle: 'Use Template',
  templateLabel: 'Template',
  noIdFallback: 'No ID',
  searchTemplatePlaceholder: 'Search by article ID or name...',
  noTemplatesFound: 'No templates found',
  partsToBeConsumed: 'Parts that will be consumed:',
  part: 'Part',
  sku: 'SKU',
  qty: 'Qty',
  serialNumberLabel: 'Serial Number',
  serialNumberPlaceholder: 'Serial Number (optional)',
  createEquipmentButton: 'Create Equipment',
  searchPartPlaceholder: 'Search part to add...',
  noPartsFound: 'No parts found',
  addPartButton: '+ Add',
  selectedLabel: 'Selected:',
  stock: 'Stock',
  isComponentLabel: 'This template is a buildable component (e.g. a sub-assembly that can be built into another item)',
  componentsWithCount: 'Required components ({{count}})',
  searchComponentPlaceholder: 'Search component template to add...',
  noComponentTemplatesFound: 'No component templates found',
  addComponentButton: '+ Add',
  noComponentsAdded: 'No components added',
  component: 'Component',
  componentBadge: 'Component',
  componentsCount: '{{count}} components',
  componentsConfiguration: 'Required Components',
  componentsToBeConsumed: 'Components that will be consumed:',
  currentStock: 'Current Stock',
  componentStockWillGoNegative: 'Not enough of a component is currently in stock -- production will continue and its stock will go negative.',
  componentsStockTitle: 'Ready component stock',
};

const de = {
  errorFetchingDetails: 'Fehler beim Abrufen der Vorlagendetails: {{message}}',
  errorLoadingDetails: 'Fehler beim Laden der Details: {{message}}',
  errorLoadingTemplate: 'Fehler beim Laden der Vorlage: {{message}}',
  pleaseAddPart: 'Bitte fügen Sie mindestens ein Teil hinzu',
  failedToCreate: 'Vorlage konnte nicht erstellt werden: {{error}}',
  failedToUpdate: 'Vorlage konnte nicht aktualisiert werden: {{error}}',
  failedToDelete: 'Vorlage konnte nicht gelöscht werden: {{error}}',
  equipmentCreatedSuccess: 'Ausrüstung erfolgreich erstellt!',
  componentStockAddedSuccess: 'Komponentenbestand erfolgreich aktualisiert!',
  failedToCreateEquipment: 'Ausrüstung konnte nicht erstellt werden: {{error}}',
  erpBookingFailed:
    'ACHTUNG: Die Ausrüstung wurde erstellt, aber die Buchung im ERP ist FEHLGESCHLAGEN: {{error}}{{doc}}\nBitte diese Produktion manuell im ERP buchen.',
  title: 'Ausrüstungsvorlagen',
  subtitle: 'Wiederverwendbare Ausrüstungskonfigurationen verwalten',
  createTemplateButton: '+ Vorlage erstellen',
  brand: 'Marke',
  articleId: 'Artikelnummer',
  parts: 'Teile',
  partsCount: '{{count}} Teile',
  use: 'Verwenden',
  createTemplateModalTitle: 'Ausrüstungsvorlage erstellen',
  templateNameLabel: 'Vorlagenname *',
  articleIdPlaceholder: 'z. B. ART-001',
  partsWithCount: 'Teile ({{count}})',
  createTemplateSubmit: 'Vorlage erstellen',
  editTemplateModalTitle: 'Vorlage bearbeiten',
  duplicate: 'Duplizieren',
  duplicateTemplateModalTitle: 'Vorlage duplizieren',
  copySuffix: '(Kopie)',
  saveChanges: 'Änderungen speichern',
  templateDetailsModalTitle: 'Vorlagendetails',
  templateNameField: 'Vorlagenname',
  partsConfiguration: 'Teilekonfiguration',
  deleteTemplateTitle: 'Vorlage löschen',
  deleteTemplateMessage: 'Sind Sie sicher, dass Sie „{{name}}“ löschen möchten?',
  useTemplateModalTitle: 'Vorlage verwenden',
  templateLabel: 'Vorlage',
  noIdFallback: 'Keine ID',
  searchTemplatePlaceholder: 'Nach Artikelnummer oder Name suchen...',
  noTemplatesFound: 'Keine Vorlagen gefunden',
  partsToBeConsumed: 'Teile, die verbraucht werden:',
  part: 'Teil',
  sku: 'Artikelcode',
  qty: 'Menge',
  serialNumberLabel: 'Seriennummer',
  serialNumberPlaceholder: 'Seriennummer (optional)',
  createEquipmentButton: 'Ausrüstung erstellen',
  searchPartPlaceholder: 'Teil zum Hinzufügen suchen...',
  noPartsFound: 'Keine Teile gefunden',
  addPartButton: '+ Hinzufügen',
  selectedLabel: 'Ausgewählt:',
  stock: 'Bestand',
  isComponentLabel: 'Diese Vorlage ist eine baubare Komponente (z. B. eine Baugruppe, die in ein anderes Produkt eingebaut werden kann)',
  componentsWithCount: 'Benötigte Komponenten ({{count}})',
  searchComponentPlaceholder: 'Komponentenvorlage zum Hinzufügen suchen...',
  noComponentTemplatesFound: 'Keine Komponentenvorlagen gefunden',
  addComponentButton: '+ Hinzufügen',
  noComponentsAdded: 'Keine Komponenten hinzugefügt',
  component: 'Komponente',
  componentBadge: 'Komponente',
  componentsCount: '{{count}} Komponenten',
  componentsConfiguration: 'Benötigte Komponenten',
  componentsToBeConsumed: 'Komponenten, die verbraucht werden:',
  currentStock: 'Aktueller Bestand',
  componentStockWillGoNegative: 'Nicht genügend Bestand einer Komponente vorhanden -- die Produktion wird trotzdem fortgesetzt und der Bestand wird negativ.',
  componentsStockTitle: 'Einsatzbereite Komponenten auf Lager',
};

const equipmentTemplates = { en, de };
export default equipmentTemplates;
